import React from 'react'

import './BoxContainer.css'

interface BoxContainerProps {
	children: React.ReactNode
}

function BoxContainer(props: BoxContainerProps) {
	return <div className='boxContainer'>{props.children}</div>
}

export default BoxContainer
